import React from 'react';

const addMinutes = (hhmm, mins) => {
  const [h, m] = hhmm.split(':').map(Number);
  const t = (h * 60 + m + mins) % (24 * 60);
  return `${String(Math.floor(t / 60)).padStart(2, '0')}:${String(t % 60).padStart(2, '0')}`;
};

const TIMES = Array.from({ length: 16 * 4 }, (_, i) => addMinutes('08:00', i * 15));

const TimeSelect = ({ value, onChange, testId }) => (
  <select value={value} onChange={e => onChange(e.target.value)} className="flex-1 px-3 py-2 border rounded-lg" data-testid={testId}>
    <option value="">--:--</option>
    {TIMES.map(t => <option key={t} value={t}>{t}</option>)}
    {value && !TIMES.includes(value) && <option value={value}>{value}</option>}
  </select>
);

export const TimeRangeInput = ({ value, onChange, testId }) => {
  const [start = '', end = ''] = (value || '').split('-');
  return (
    <div className="flex items-center gap-2" data-testid={testId}>
      <TimeSelect value={start} onChange={s => onChange(s ? `${s}-${addMinutes(s, 90)}` : '')} testId={`${testId}-start`} />
      <span className="text-slate-400">–</span>
      <TimeSelect value={end} onChange={e => onChange(start ? `${start}-${e}` : '')} testId={`${testId}-end`} />
    </div>
  );
};

export const VenueSelect = ({ value, onChange, venues, testId }) => (
  <select value={value || ''} onChange={e => onChange(e.target.value)} className="w-full px-3 py-2 border rounded-lg" data-testid={testId}>
    <option value="">— Επιλογή γηπέδου —</option>
    {venues.map(v => <option key={v.id} value={v.name}>{v.name}</option>)}
    {value && !venues.some(v => v.name === value) && <option value={value}>{value}</option>}
  </select>
);
